export default [ // rating order configuration
    // "stationSurroundingAverage",
    "locationAverageRating",
    "skiAreaAverage",
    "surroundingsAverageRating",
    "valueForMoneyAverageRating"
]